import system from "system-components";

export const StyledForm = system({
  is: "form",
  px: 5,
  my: 5
});
StyledForm.displayName = "StyledForm";
